const apiUrl = process.env.VITE_API_URL
const baseDomain = process.env.VITE_BASE_DOMAIN
const isLocalHost = window.location.hostname === 'localhost'
const devMode = process.env.VITE_ENV_MODE === 'development'
const isProduction = process.env.VITE_ENV_MODE === 'production'
const posthogApiKey = process.env.VITE_POSTHOG_API_KEY
const posthogApiHost = process.env.VITE_POSTHOG_API_HOST

export { apiUrl, baseDomain, isLocalHost, devMode, isProduction, posthogApiKey, posthogApiHost }
